import { MOBILE_BREAKPOINT } from "@/config/constants";
import { useWindowSize } from "./use-window-size";

export default function useMobile() {
  const { width } = useWindowSize();
  const isMobile = width < MOBILE_BREAKPOINT;
  return { isMobile };
}
